import { useQuery } from '@tanstack/react-query'
import { DriverModel } from '@/app/models'
import useDriverService from '@/modules/drivers/services/DriverService'

interface UseQueryDriversProps {
  companyId: string
  enabled?: boolean
}

export function useQueryDrivers({
  companyId,
  enabled = true,
}: UseQueryDriversProps) {
  const {getDrivers} = useDriverService()

  return useQuery<DriverModel[]>({
    queryKey: ['drivers', companyId],
    queryFn: async () => {
      const data = await getDrivers({ companyId, onlyActive: true })
      return data || []
    },
    enabled: !!companyId && enabled,
    staleTime: 1000 * 60 * 5, // 5 minutes
  })
}

